<template>
    <div class="columns is-multiline">
      <div class="column is-half">
        <window title="Masked input <a href='https://github.com/niksmr/vue-masked-input'
                                       target='_blank'>(more info)</a>" height="100%">
          <masked-input class="input" v-model="maskedInput.date" mask="11/11/1111"
            placeholder="dd/mm/yyyy"
          />
          <p class="help">{{maskedInput.date}}</p>
        </window>
      </div>
      <div class="column is-half">
        <window title="Masked input <a href='https://github.com/niksmr/vue-masked-input'
                                       target='_blank'>(more info)</a>" height="100%">
          <masked-input class="input" v-model="maskedInput.phone1" mask="\+\1 (111) 111-1111"
            placeholder="Phone number" type="tel"
          />
          <p class="help">{{maskedInput.phone1}}</p>
        </window>
      </div>
      <div class="column is-half">
        <window title="Masked input <a href='https://github.com/niksmr/vue-masked-input'
                                       target='_blank'>(more info)</a>" height="100%">
          <masked-input class="input" mask="\+\1 (111) 1111-11" placeholder="Phone"
            @input="maskedInput.rawVal = arguments[1]"
          />
          <p class="help">{{maskedInput.rawVal}}</p>
        </window>
      </div>
      <div class="column is-half">
        <window title="Masked input <a href='https://github.com/niksmr/vue-masked-input'
                                       target='_blank'>(more info)</a>" height="100%">
          <masked-input class="input" v-model="maskedInput.phone2" mask="\+\1 (111) 111-1111"
            placeholder-char="-" placeholder="Phone number" type="tel"
          />
          <p class="help">{{maskedInput.phone2}}</p>
        </window>
      </div>
      <div class="column is-full">
        <window title="Masked input <a href='https://github.com/niksmr/vue-masked-input'
                                       target='_blank'>(more info)</a>" height="100%">
          <div class="field">
            <label class="label">Pattern</label>
            <div class="control">
              <input class="input" v-model="maskedInput.customPattern"
                placeholder="Custom pattern" type="text"
              >
            </div>
          </div>
          <div class="field">
            <label class="label">Custom</label>
            <div class="control">
              <masked-input class="input" v-model="maskedInput.customOutput" placeholder="Custom"
                    :mask="{
                        pattern: maskedInput.customPattern,
                        formatCharacters: {
                        'V': {
                            validate: char => /[a-jA-J]/.test(char),
                            transform: char => char.toUpperCase(),
                        },
                        },
                    }" />
              <p class="help">{{maskedInput.customOutput}}</p>
            </div>
          </div>
        </window>
      </div>
    </div>
</template>

<script>
import MaskedInput from 'vue-masked-input';

export default {
  data() {
    return {
      maskedInput: {
        date: '',
        phone1: '',
        phone2: '',
        rawVal: '',
        customPattern: 'aa-aa-AAAA',
        customOutput: '',
      },
    };
  },
  components: { MaskedInput },
};
</script>
